import styled from 'styled-components'

import { Container } from '../../styles/defaults'
import { minmedia } from '../../styles/media-queries';

export const Section = Container.extend`
  margin-bottom: 2rem;

  ${minmedia.large`
    margin-bottom: 4rem;
  `}
`

export const Title = styled.h3`
  font-weight: 500;
  font-size: 16px;
  margin-bottom: .5rem;

  ${minmedia.large`
    font-size: 24px;
    margin-bottom: 3rem;
  `}
`


// WEBPACK FOOTER //
// ./src/components/Branch/styles.js